import React, { useState } from "react";

const GalleryViewModal = ({ gallery, onClose }) => {
  const [activeImage, setActiveImage] = useState(0);

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl w-full max-w-3xl shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 bg-green-50 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800">Gallery Details</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500 transition"
          >
            ✕
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Images */}
          {gallery.image?.length > 0 && (
            <div>
              <div className="rounded-xl overflow-hidden h-64 bg-gray-100">
                <img
                  src={gallery.image[activeImage]}
                  alt={gallery.heading}
                  className="w-full h-full object-cover"
                />
              </div>
              {gallery.image.length > 1 && (
                <div className="flex gap-2 mt-3 flex-wrap">
                  {gallery.image.map((img, i) => (
                    <button
                      key={i}
                      onClick={() => setActiveImage(i)}
                      className={`w-14 h-14 rounded-lg overflow-hidden border-2 transition ${
                        activeImage === i
                          ? "border-green-500"
                          : "border-gray-200"
                      }`}
                    >
                      <img
                        src={img}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Title */}
          <div>
            <h3 className="text-2xl font-bold text-gray-800 leading-snug">
              {gallery.heading}
            </h3>
            {/* <div className="flex items-center gap-2 mt-2">
              <span className="text-xs text-gray-400">📅 Published:</span>
              <span className="text-xs text-gray-500">{formatDate(blog.publishedDate)}</span>
            </div> */}
          </div>

          {/* <div className="bg-gray-50 rounded-xl p-5">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Content</p>
            <div
              className="text-sm text-gray-700 leading-relaxed prose max-w-none"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />
          </div> */}
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default GalleryViewModal;
